// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useNavigate, Link } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-shrug">{'\u00AF\\_(\u30C4)_/\u00AF'}</div>
        <h1 className="not-found-title">Page Not Found</h1>
        <p className="not-found-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="not-found-actions">
          <button className="not-found-back-btn" onClick={() => navigate(-1)}>
            Go Back
          </button>
          <Link to="/site" className="not-found-home-link">
            Go to Sites
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
